import { ComponentProps, ComponentType } from 'react';
import { Formik } from 'formik';

import { createContext } from '@/react/utils/context';

import { StepConfig, WizardStepState } from '@@/Stepper/useWizardSteps';

export type WizardStep = StepConfig & {
  Component: ComponentType;
  validateStep: () => ComponentProps<typeof Formik>['validationSchema'];
};

/** Lets the shared steps tell whether they are creating a workflow or editing one. */
export const WizardMode = {
  Create: 'create',
  Edit: 'edit',
} as const;

export type WizardMode = (typeof WizardMode)[keyof typeof WizardMode];

export type WizardContextValue = WizardStepState<WizardStep> & {
  mode: WizardMode;
  /**
   * Number of artifact config steps to render. Owned outside Formik (the
   * step list is built before the form mounts), kept in sync by whichever
   * step can add or remove artifacts.
   */
  artifactCount: number;
  /** Absent in edit mode, where artifacts can't be added or removed. */
  setArtifactCount?: (count: number) => void;
};

const { Provider: WizardProvider, useContext: useWizardContext } =
  createContext<WizardContextValue>('WizardContext');

export { WizardProvider, useWizardContext };
